export function resolveUserPhoneUser(user) {
    return user?.localUser?.phoneUser?.trim() || user?.phoneUser?.trim() || '';
}
export const USER_LANG_KEY_OPTIONS = [
    { label: 'English', value: 'en' },
    { label: 'Dari', value: 'fa' },
    { label: 'Pashto', value: 'ps' },
];
export const defaultValue = {
    id: '',
    login: '',
    username: '',
    firstName: '',
    lastName: '',
    fullName: '',
    email: '',
    activated: true,
    langKey: '',
    authorities: [],
    roles: [],
    branches: [],
    status: 'ACTIVE',
    phoneIp: '',
    phonePort: 0,
    phoneUser: '',
    phonePassword: '',
    createdBy: '',
    createdDate: null,
    lastModifiedBy: '',
    lastModifiedDate: null,
    password: '',
};
